export default __webpack_public_path__ + "static/media/check.5a9d0791.svg";